export default function ({ store, redirect, app }) {
	return redirect('/?savings-center=true')
}